import { createIconComponent } from '../../factory/create-icon-component';
export const BoxIcon = createIconComponent(
  'BoxIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.49982 9.50002L13.2271 6.00003M11.9999 12.5L20.9999 7.00003M11.9999 12.5L2.99994 7.00003M11.9999 12.5V22.5M14.4695 2.48177L19.6695 5.60177C20.5193 6.11165 20.9442 6.36659 21.2529 6.71759C21.526 7.02821 21.7319 7.39194 21.8577 7.78595C21.9999 8.2312 21.9999 8.72671 21.9999 9.71774V10V15.4999C21.9871 15.5838 21.9736 15.6624 21.959 15.7374C21.9335 15.8693 21.9207 15.9352 21.7647 16.2697C21.672 16.4684 21.3662 16.9159 21.2147 17.0744C20.9598 17.3412 20.7598 17.4675 20.3599 17.7201L14.4986 21.4219C13.5914 21.9949 13.1378 22.2814 12.65 22.3967C12.2186 22.4988 11.7699 22.5039 11.3363 22.4118C10.846 22.3076 10.3859 22.0316 9.46583 21.4796L8.6666 21L5.33327 19L4.33036 18.3983C3.48056 17.8884 3.05566 17.6335 2.74702 17.2825C2.4739 16.9718 2.26796 16.6081 2.14213 16.2141C1.99994 15.7689 1.99994 15.2733 1.99994 14.2823V9.71774C1.99994 8.72671 1.99994 8.2312 2.14213 7.78595C2.26796 7.39194 2.4739 7.02821 2.74702 6.71759C3.05566 6.36659 3.48056 6.11165 4.33036 5.60177L9.53036 2.48177C10.4283 1.94303 10.8772 1.67366 11.3565 1.56842C11.7804 1.47532 12.2195 1.47532 12.6434 1.56842C13.1227 1.67366 13.5716 1.94303 14.4695 2.48177Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
